var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgGuestUser = function SvgGuestUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.314 4.686A15.895 15.895 0 0016 0 15.895 15.895 0 004.686 4.686 15.895 15.895 0 000 16c0 4.274 1.664 8.292 4.686 11.314A15.895 15.895 0 0016 32c4.274 0 8.292-1.664 11.314-4.686A15.895 15.895 0 0032 16c0-4.274-1.664-8.292-4.686-11.314zM16 30.125a14.076 14.076 0 01-9.8-3.964 10.33 10.33 0 019.8-7.099 10.33 10.33 0 019.8 7.1 14.077 14.077 0 01-9.8 3.963zM11.312 12.5A4.693 4.693 0 0116 7.812a4.693 4.693 0 014.688 4.688A4.693 4.693 0 0116 17.188a4.693 4.693 0 01-4.688-4.688zM27.21 24.585a12.222 12.222 0 00-7.361-6.772 6.558 6.558 0 002.715-5.313A6.57 6.57 0 0016 5.937 6.57 6.57 0 009.437 12.5a6.558 6.558 0 002.715 5.313 12.223 12.223 0 00-7.36 6.772A14.052 14.052 0 011.874 16C1.875 8.211 8.211 1.875 16 1.875S30.125 8.211 30.125 16c0 3.227-1.088 6.204-2.916 8.585z",
    fill: "#fff"
  })));
};

export default SvgGuestUser;